import React from 'react';
import { Menu, Row, Col, PageHeader, Card, message } from 'antd'
import { NavLink } from 'react-router-dom'
import axios from '../../axios/index';
import moment from 'moment'

import './index.less'
const SubMenu = Menu.SubMenu;

export default class NavLeft extends React.Component {

    state = {
        recentReplay: [],
        cate: [],
        slug: [],
        date: [],
        other: []
    }

    componentWillMount() {
        // const menuTreeNode = this.renderMenu(MenuConfig);
        // this.setState({
        //     menuTreeNode
        // })
        this.renderList({ url: '/comments/getlatest', data: {}, func: this.renderReplay });
        this.renderList({ url: '/contents/getcate', data: {}, func: this.renderCate });
        this.renderList({ url: '/contents/getslug', data: {}, func: this.renderSlug });
        this.renderList({ url: '/contents/getdate', data: {}, func: this.renderDate });
        this.renderList({ url: '/feedback/feedback', data: {}, func: this.renderOther });
    }

    renderList = (data) => {
        let _this = this;
        axios.ajax({
            url: data.url,
            data: data.data
        }).then(res => {
            data.func(res.data);
        }).catch(e => {
            // if (e.code === -1) {
            //     message.error(e.message);
            //     return;
            // }
        })
    }

    renderReplay = (data) => {
        this.state.recentReplay = data;
        let list = this.state.recentReplay.map(item => {
            return <NavLink className="navlink" to={`/home/list/cid=${item.cid}`} key={item.text}>{item.text}</NavLink>
        });
        this.setState({
            recentReplay: list
        })
    }
    renderCate = (data) => {
        this.state.cate = data;
        let list = this.state.cate.map(item => {
            return <NavLink className="navlink" to={`/home/list/type=${item.type}`} key={item.type}>{item.type + "(" + item.count + ")"}</NavLink>
        });
        this.setState({
            cate: list
        })
    }
    renderSlug = (data) => {
        this.state.slug = data;
        let list = this.state.slug.map(item => {
            return <NavLink className="navlink" to={`/home/list/slug=${item.slug}`} key={item.slug}>{item.slug + "(" + item.count + ")"}</NavLink>
        });
        this.setState({
            slug: list
        })
    }
    renderDate = (data) => {
        this.state.date = data;
        let list = this.state.date.map(item => {
            return <NavLink className="navlink" to={`/home/list/createTime=${item.createTime}`} key={item.createTime}>{moment(item.createTime).format('YYYY年MM月') + "(" + item.count + ")"}<br /></NavLink>
        });
        this.setState({
            date: list
        })
    }
    renderOther = (data) => {
        this.state.other = data;
        let list = this.state.other.map(item => {
            return <NavLink className="navlink" to={`/home/list/other=${item.other}`} key={item.other}>{item.other}</NavLink>
        });
        this.setState({
            other: list
        })
    }

    render() {
        const headStyle = {
            paddingLeft: 0
        }
        return (
            <div>
                <Row>
                    <Col>
                        <Card bordered={false} title="最近回复" headStyle={headStyle}>{this.state.recentReplay}</Card>
                        <Card bordered={false} title="分类" headStyle={headStyle}>{this.state.cate}</Card>
                        <Card bordered={false} title="标签" headStyle={headStyle}>{this.state.slug}</Card>
                        <Card bordered={false} title="归档" headStyle={headStyle}>{this.state.date}</Card>
                        <Card bordered={false} title="其他" headStyle={headStyle}>{this.state.other}</Card>
                    </Col>
                </Row>
            </div>
        );
    }
}